import { render, staticRenderFns } from "./MultiQuestionPartial.vue?vue&type=template&id=cfb0e706&scoped=true&"
import script from "./MultiQuestionPartial.vue?vue&type=script&lang=js&"
export * from "./MultiQuestionPartial.vue?vue&type=script&lang=js&"
import style0 from "./MultiQuestionPartial.vue?vue&type=style&index=0&id=cfb0e706&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb0e706",
  null
  
)

export default component.exports